import {Component, OnInit } from '@angular/core';
import {UserManagementService} from 'app/services/user-management.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Location} from '@angular/common';
import {DataService} from 'app/services/data.service';
import {FrontEndService} from "../../services/front-end.service";
import {StateService, Transition} from '@uirouter/angular';

@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.scss']
})

export class UserManagementComponent implements OnInit {
    user_data = [];
    selectedUser = 0;
    fullScreenLoader = false;
    currentUserProfile:any;
    currentUserUsername:any;
    currentUserRole:any;

    public modalRef: NgbModalRef;
    closeResult: string;

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private _location: Location,
        private stateService: StateService,
        private transition: Transition,
    ) {
    }

    ngOnInit() {

        if (localStorage.getItem('currentUserProfile')) {
            this.currentUserProfile = JSON.parse(localStorage.getItem('currentUserProfile'));
            this.currentUserUsername = this.currentUserProfile.username;
            this.currentUserRole = this.currentUserProfile.role
        }
        if (localStorage.getItem('currentUserProfile')) {
            this.currentUserProfile = JSON.parse(localStorage.getItem('currentUserProfile'));
            if(this.currentUserProfile.role > 1 && this.currentUserProfile.role !== 4) {
                this.stateService.go("Forbidden")
            }
        }

        if (this.transition.params().user_id !== "" && this.transition.params().user_id !== undefined) {
            this.selectedUser = this.transition.params().user_id;
        }

        this.getUsers();
    }

    getUsers() {
        this.fullScreenLoader = true;
        this.user_management_service.userList((resp) => {
            this.fullScreenLoader = false;
            this.user_data = resp.data;
        });
    }

    changeUserRole(e, user_id, i) {
        this.fullScreenLoader = true;
        const role_id = e.value;
        this.user_management_service.userRole(role_id, user_id, (resp) => {
            setTimeout(() => {
                this.fullScreenLoader = false;
                if(resp.status === true) {
                    this.front_end_service.addToast(
                        "Success",
                        "user_role_changed_successfully",
                        "success"
                    );
                }
            }, 500);
        });
    }

    isActive(is_verified, user_id, i) {
        this.fullScreenLoader = true;
        this.user_management_service.userVerified(!is_verified, user_id, (resp) => {
            this.fullScreenLoader = false;
            if (resp.status === true) {
                this.user_data[i]["is_active"] = !this.user_data[i]["is_active"];
                this.front_end_service.addToast(
                    "Success",
                    "user_status_changed_successfully",
                    "success"
                );
            }
        });
    }

    resetPassword(index) {
        this.user_management_service.resetPassword(this.user_data[index], (resp) => {
            if(resp.status) {
                this.front_end_service.addToast(
                    "Success",
                    resp.message,
                    "success"
                );
            }
        });
    }

    open(content) {
        this.modalRef = this.modalService.open(content, { size: 'lg' });

        this.modalRef.result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${DataService.getDismissReason(reason)}`;
        });
    }

    uploadDone() {
        // Function to handle upload done
    }

    importExcel(files) {
        this.fullScreenLoader = true;
        const data = {
            "file": files[0]
        };
        this.user_management_service.importExcel(data, (response) => {
            this.fullScreenLoader = false;
            if (response.status) {
                this.front_end_service.addToast("success", "data_imported_successfully", "success");
                this.getUsers();
            }
        });
        this.modalRef.close();
    }

    exportData() {
        this.fullScreenLoader = true;
        this.user_management_service.exportData((response) => {
            this.fullScreenLoader = false;
        });
    }
}
